import React, { useContext } from 'react';

type HypothesesChangesContextT = {
    hasChanges: boolean;
    setHasChanges: React.Dispatch<React.SetStateAction<boolean>>;
};

const HypothesesChangesContext = React.createContext<HypothesesChangesContextT>(
    {
        hasChanges: false,
        setHasChanges: () => {},
    },
);

export const useHypothesesChangesContext = () =>
    useContext(HypothesesChangesContext);

export default HypothesesChangesContext;
